// Slider and video initialisations for the modules ported from ava-matrix (from ava's
// regular/general.js). Each block only acts on classes/ids of the new templates.

$(document).ready(function () {
	var $slider = $('.slider-clienti-one-row').not('.customers-slide.v2 .slider-clienti-one-row');

	$slider.on('init afterChange', function (event, slick, currentSlide) {
		var current = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide;
		var total = slick.slideCount;
		var visible = slick.options.slidesToShow || 1;
		var lastIndex = Math.max(total - visible, 0);

		var $prev = $(slick.$prevArrow);
		var $next = $(slick.$nextArrow);

		if (current === 0) {
			$prev.hide();
		} else {
			$prev.show();
		}

		if (current >= lastIndex) {
			$next.hide();
		} else {
			$next.show();
		}
	});

	$slider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 1000,
		speed: 500,
		pauseOnHover: true,
		swipe: true,
		draggable: true,
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 3 }
			},
			{
				breakpoint: 767,
				arrows: false,
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 2 }
			}
		]
	});
});

$(document).ready(function () {
	var sliderNews = new Swiper('.slider-news', {
		// fallback (dacă nu prinde niciun breakpoint)
		slidesPerView: 1.1,
		spaceBetween: 20,
		loop: false,
		navigation: false,
		pagination: false,
		allowTouchMove: true,

		breakpoints: {
			// telefoane mici
			0: {
				slidesPerView: 1.2,
				spaceBetween: 16
			},
			// telefoane mari / mici landscape
			576: {
				slidesPerView: 1.4,
				spaceBetween: 20
			},
			// tablete
			768: {
				slidesPerView: 1.5,
				spaceBetween: 24
			},
			// laptopuri / desktop mediu
			1024: {
				slidesPerView: 2.45,
				spaceBetween: 30
			},
			// monitoare mari
			1440: {
				slidesPerView: 3.45,
				spaceBetween: 30
			}
		}
	});
});

$(document).ready(function () {
	const swiper = new Swiper('.testimonial-swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		centeredSlides: false,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: false,
	});
});

$(document).ready(function () {
	var gallerySwiper = new Swiper('.gallerySwiper', {
		slidesPerView: 2.3,
		centeredSlides: true,
		spaceBetween: 20,
		loop: true,

		navigation: {
			nextEl: '.gallery-next',
			prevEl: '.gallery-prev',
		},
		breakpoints: {
			0: {
				slidesPerView: 1.3,
				centeredSlides: true,
			},
			768: {
				slidesPerView: 1.6,
				centeredSlides: true,
			},
			1024: {
				slidesPerView: 2.3,
				centeredSlides: true,
			},
			1366: {
				slidesPerView: 3.25,
				centeredSlides: true,
			}
		}
	});
});

$(document).ready(function () {
	if ($('.tabs-video-sliders').length > 0) {
		const slider = document.querySelector('.tabs-video-sliders');
		if (slider) {
			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', e => {
				isDown = true;
				slider.style.cursor = 'grabbing';
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});

			slider.addEventListener('mouseleave', () => {
				isDown = false;
				slider.style.cursor = 'grab';
			});

			slider.addEventListener('mouseup', () => {
				isDown = false;
				slider.style.cursor = 'grab';
			});

			slider.addEventListener('mousemove', e => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX) * 2;
				slider.scrollLeft = scrollLeft - walk;
			});
		}
	}
});

document.addEventListener('DOMContentLoaded', function () {
	new Swiper('.team-swiper', {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: false,

		navigation: {
			nextEl: '.team-swiper .swiper-button-next',
			prevEl: '.team-swiper .swiper-button-prev',
		},

		speed: 600,
	});
});

document.addEventListener('DOMContentLoaded', function () {
	new Swiper('.center-swiper', {
		slidesPerView: 3,
		centeredSlides: true,
		spaceBetween: 16,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slideToClickedSlide: true,
		breakpoints: {
			0: {
				slidesPerView: '2.3',
				centeredSlides: true,
				spaceBetween: 12,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			}
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const partnersTestimonialsSwiper = new Swiper('.swiper-partners-testimonials', {
		slidesPerView: 1,
		spaceBetween: 40,
		loop: true,

		navigation: {
			nextEl: '.swiper-partners-testimonials-next',
			prevEl: '.swiper-partners-testimonials-prev',
		},
		breakpoints: {
			0: {
				spaceBetween: 12,
			},
			768: {
				spaceBetween: 16,
			},
			1024: {
				spaceBetween: 40,
			}
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const linksSwiperEl = document.querySelector('.links-swiper');
	if (!linksSwiperEl) return;

	const speed = window.matchMedia('(max-width: 767px)').matches ? 3000 : 5000;

	new Swiper(linksSwiperEl, {
		slidesPerView: 'auto',
		spaceBetween: 20,
		loop: true,
		freeMode: true,
		freeModeMomentum: false,
		speed: speed,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		allowTouchMove: false
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const wrapper = document.getElementById('heroVideoTextWrapper');
	if (wrapper) {
		const video = document.getElementById('heroVideoText');

		const playBtn = document.getElementById('playPauseToggleText');
		const volumeBtn = document.getElementById('volumeToggleText');

		const playIcon = playBtn.querySelector('i');
		const volumeIcon = volumeBtn.querySelector('i');

		video.muted = true;
		let userPaused = false;

		function setPlayIcon(isPlaying) {
			playIcon.classList.remove('fa-play', 'fa-pause');
			playIcon.classList.add(isPlaying ? 'fa-pause' : 'fa-play');
		}

		async function safePlay() {
			try {
				await video.play();
				setPlayIcon(true);
			} catch (e) {
				setPlayIcon(false);
			}
		}

		function safePause() {
			video.pause();
			setPlayIcon(false);
		}

		playBtn.addEventListener('click', function (e) {
			e.preventDefault();

			if (video.paused) {
				userPaused = false;
				safePlay();
			} else {
				userPaused = true;
				safePause();
			}
		});

		volumeBtn.addEventListener('click', function (e) {
			e.preventDefault();

			video.muted = !video.muted;

			volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
			volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;

				if (inView) {
					if (!userPaused) safePlay();
				} else {
					safePause();
				}
			});
		}, {
			threshold: [0, 0.5, 1.0]
		});

		observer.observe(wrapper);

		setPlayIcon(false);
		volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
		volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const wrapper = document.getElementById('heroVideoTextLeftLeftWrapper');
	if (wrapper) {
		const video = document.getElementById('heroVideoTextLeft');

		const playBtn = document.getElementById('playPauseToggleTextLeft');
		const volumeBtn = document.getElementById('volumeToggleTextLeft');

		const playIcon = playBtn.querySelector('i');
		const volumeIcon = volumeBtn.querySelector('i');

		video.muted = true;

		let userPaused = false;

		function setPlayIcon(isPlaying) {
			playIcon.classList.remove('fa-play', 'fa-pause');
			playIcon.classList.add(isPlaying ? 'fa-pause' : 'fa-play');
		}

		async function safePlay() {
			try {
				await video.play();
				setPlayIcon(true);
			} catch (e) {
				setPlayIcon(false);
			}
		}

		function safePause() {
			video.pause();
			setPlayIcon(false);
		}

		playBtn.addEventListener('click', function (e) {
			e.preventDefault();

			if (video.paused) {
				userPaused = false;
				safePlay();
			} else {
				userPaused = true;
				safePause();
			}
		});

		volumeBtn.addEventListener('click', function (e) {
			e.preventDefault();

			video.muted = !video.muted;

			volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
			volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;

				if (inView) {
					if (!userPaused) safePlay();
				} else {
					safePause();
				}
			});
		}, {
			threshold: [0, 0.5, 1.0]
		});

		observer.observe(wrapper);

		setPlayIcon(false);
		volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
		volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const wrapper = document.getElementById('heroVideoWrapper');
	if (wrapper) {
		const video = document.getElementById('heroVideo');

		const playBtn = document.getElementById('playPauseToggle');
		const volumeBtn = document.getElementById('volumeToggle');

		const playIcon = playBtn.querySelector('i');
		const volumeIcon = volumeBtn.querySelector('i');

		video.muted = true;

		let userPaused = false;

		function setPlayIcon(isPlaying) {
			playIcon.classList.remove('fa-play', 'fa-pause');
			playIcon.classList.add(isPlaying ? 'fa-pause' : 'fa-play');
		}

		async function safePlay() {
			try {
				await video.play();
				setPlayIcon(true);
			} catch (e) {
				setPlayIcon(false);
			}
		}

		function safePause() {
			video.pause();
			setPlayIcon(false);
		}

		playBtn.addEventListener('click', function (e) {
			e.preventDefault();

			if (video.paused) {
				userPaused = false;
				safePlay();
			} else {
				userPaused = true;
				safePause();
			}
		});

		volumeBtn.addEventListener('click', function (e) {
			e.preventDefault();

			video.muted = !video.muted;

			volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
			volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;

				if (inView) {
					if (!userPaused) safePlay();
				} else {
					safePause();
				}
			});
		}, {
			threshold: [0, 0.5, 1.0]
		});

		observer.observe(wrapper);

		setPlayIcon(false);
		volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
		volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
	}
});

document.addEventListener('DOMContentLoaded', function () {

	document.querySelectorAll('.video-round-swiper .video-item').forEach(slide => {
		const video = slide.querySelector('video');
		const overlay = slide.querySelector('.video-overlay');
		const playIcon = overlay.querySelector('.play-button i');

		overlay.addEventListener('click', function () {
			// // Allow play/pause only on the active Swiper slide
			// if (!slide.classList.contains('swiper-slide-active')) {
			// 	return;
			// }

			if (video.paused) {
				video.play();
				playIcon.classList.remove('fa-play');
				playIcon.classList.add('fa-pause');
			} else {
				video.pause();
				playIcon.classList.remove('fa-pause');
				playIcon.classList.add('fa-play');
			}
		});

		// When the video ends, switch back to the Play icon
		video.addEventListener('ended', function () {
			playIcon.classList.remove('fa-pause');
			playIcon.classList.add('fa-play');
		});
	});

	new Swiper('.video-round-swiper', {
		centeredSlides: true,
		slidesPerView: 5.5,
		spaceBetween: 12,
		speed: 450,

		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: 'bullets',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			0: { slidesPerView: 1.2 },
			480: { slidesPerView: 2.2 },
			768: { slidesPerView: 3.2 },
			1025: { slidesPerView: 3.2 },
			1441: { slidesPerView: 5.5 },
		},

		on: {
			slideChange: function () {
				// Pause every video that is NOT on the active slide
				this.slides.forEach((slideEl, idx) => {
					if (idx === this.activeIndex) return;

					const video = slideEl.querySelector('video');
					const playIcon = slideEl.querySelector('.play-button i');

					if (video) video.pause();
					if (playIcon) {
						playIcon.classList.remove('fa-pause');
						playIcon.classList.add('fa-play');
					}
				});
			}
		}
	});

});


// projects-slider template: scoped to its own root, because .slider-projects is also used by
// the existing portfolio templates (which must keep their current behaviour).
$(document).ready(function () {
	var sliderProjects = new Swiper('.template-SliderImageOnly .slider-projects', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},

		navigation: {
			nextEl: '.template-SliderImageOnly .slider-projects-next',
			prevEl: '.template-SliderImageOnly .slider-projects-prev',
		},
		pagination: false,
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/ported-general.js